<script lang="ts" setup>
import { onMounted } from 'vue';
import SceneMain from './scene3d/SceneMain'
import { globalParams } from './scene3d/global'

const { theme } = useTheme();
var scene3d: any = null;
onMounted(() => {
  const dom = document.getElementById('mouseEffect');
  if (!isMobile()) {
    const effect = new SceneMain({
      $wrapper: dom,
      allowCursor: true
    });
    scene3d = effect;
    if (theme.value === 'light') {
      globalParams.options.colorType = 1.0;
      scene3d.setType(1);
    } else {
      globalParams.options.colorType = 0.0;
      scene3d.setType(0);
    }
  }
})


watch(theme, (v) => {
  if (import.meta.client) {
    if (theme.value === 'light') {
      globalParams.options.colorType = 1.0;
      if (scene3d) {
        scene3d.setType(1);
      }
    } else {
      globalParams.options.colorType = 0.0;
      if (scene3d) {
        scene3d.setType(0);
      }
    }
  }
}, {
  immediate: true,
})
</script>

<template>
  <div class="mouse-effect" id='mouseEffect'>
  </div>
</template>


<style lang="scss" scoped>
.mouse-effect {
  position: fixed;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  pointer-events: none;

  canvas {
    width: 100%;
    height: 100vh;
  }
}
</style>